// const awsconfig = {
//     "aws_project_region": "us-east-1",
//     // "aws_cognito_identity_pool_id": "us-east-1:xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
//     "aws_cognito_region": "us-east-1",
//     "aws_user_pools_id": "us-east-1_DI1XgO9bQ",
//     "aws_user_pools_web_client_id": "1a71o86b0f46eje8ljcklpnbgv",
// };


const awsconfig = {
    Auth: {
        Cognito: {
            userPoolClientId: "1a71o86b0f46eje8ljcklpnbgv",
            userPoolId: "us-east-1_DI1XgO9bQ",
            region: "us-east-1",
        }
    },
    API: {
        REST: {
            tsService: {
                endpoint: 'https://g3y2s236i1.execute-api.us-east-1.amazonaws.com/dev',
                region: 'us-east-1'
            }
        }
    }
}


export default awsconfig;
